import Phaser from 'phaser';
import { CELL_H, CELL_W, GLYPHS, PIXEL_FONT_CHARS } from './pixelGlyphs';

export { CELL_H, CELL_W } from './pixelGlyphs';

/**
 * A hand-authored 5×7 pixel font (caps/x-height on rows 0–6, descenders on rows 7–8), generated
 * into a RetroFont at boot. Crisp at 1:1 and at integer scales, unlike a system font rasterized
 * into a 192 px canvas (playtest: "too grainy to read").
 */

export const PIXEL_FONT = 'pixel';
const PER_ROW = 16;
/** Builds the font texture and registers it in the bitmap font cache (once per game). */
export function createPixelFont(scene: Phaser.Scene): void {
  if (scene.cache.bitmapFont.exists(PIXEL_FONT)) return;
  const chars = [...PIXEL_FONT_CHARS];
  const rows = Math.ceil(chars.length / PER_ROW);
  const key = `${PIXEL_FONT}-texture`;
  const tex = scene.textures.createCanvas(key, PER_ROW * CELL_W, rows * CELL_H);
  if (!tex) throw new Error('Could not create pixel font texture');
  const ctx = tex.context;
  ctx.fillStyle = '#ffffff';
  chars.forEach((ch, i) => {
    const ox = (i % PER_ROW) * CELL_W;
    const oy = Math.floor(i / PER_ROW) * CELL_H;
    (GLYPHS[ch] ?? []).forEach((row, y) => {
      [...row].forEach((px, x) => {
        if (px === '#') ctx.fillRect(ox + x, oy + y, 1, 1);
      });
    });
  });
  tex.refresh();
  const entry = Phaser.GameObjects.RetroFont.Parse(scene, {
    image: key,
    width: CELL_W,
    height: CELL_H,
    chars: PIXEL_FONT_CHARS,
    charsPerRow: PER_ROW,
    'offset.x': 0,
    'offset.y': 0,
    'spacing.x': 0,
    'spacing.y': 0,
    lineSpacing: 0,
  });
  // Phaser 4's Parse returns the complete cache entry ({ data, texture, frame }).
  scene.cache.bitmapFont.add(PIXEL_FONT, entry);
}
